import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\repos\\ERP-Frontend\\src\\app\\components\\DashboardAlerts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\repos\\ERP-Frontend\\src\\app\\components\\DashboardCharts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\repos\\ERP-Frontend\\src\\app\\components\\DashboardKPICards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\repos\\ERP-Frontend\\src\\app\\components\\DashboardRecentTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\repos\\ERP-Frontend\\src\\components\\AppLayout.tsx");
